import { SCREENS } from "../navigation";
import type { ScreenId } from "../navigation";

interface NavTabsProps {
  active: ScreenId;
  onChange: (screen: ScreenId) => void;
  /** Screen ids that should show a "something is happening" dot, e.g. "runs" while indexing. */
  runningIndicatorFor?: ScreenId[];
  /** Screen ids to omit, for capabilities this deployment has switched off. */
  hidden?: readonly ScreenId[];
}

export function NavTabs({
  active,
  onChange,
  runningIndicatorFor = [],
  hidden = [],
}: NavTabsProps): JSX.Element {
  return (
    <nav className="nav-tabs" aria-label="Admin sections">
      {SCREENS.filter((screen) => !hidden.includes(screen.id)).map((screen) => (
        <button
          key={screen.id}
          type="button"
          className={`nav-tabs__item${screen.id === active ? " nav-tabs__item--active" : ""}`}
          aria-current={screen.id === active ? "page" : undefined}
          onClick={() => onChange(screen.id)}
        >
          {screen.label}
          {runningIndicatorFor.includes(screen.id) && (
            <span
              className="nav-tabs__dot"
              aria-label="indexing in progress"
              title="Indexing in progress"
            />
          )}
        </button>
      ))}
    </nav>
  );
}
